import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class PenaltyDeclined extends Fragment {
    constructor() {
        super();
        this.code = "D";
    }

    summarize(summaryContext, stringifier) {
        const message = "Declined";
        const titleMessage =
            summaryContext.triggerKO && !summaryContext.isKickOffPlay
                ? `Kickoff from ${stringifier.niceFieldPosition(
                      summaryContext.gameConfig.general.fieldLength,
                      summaryContext.fieldPosition,
                      summaryContext.homeTeam?.abbrName,
                      summaryContext.awayTeam?.abbrName
                  )}`
                : summaryContext.triggerPAT
                ? "PAT: Penalty"
                : null;
        return new FragmentSummary(message, titleMessage);
    }

    updateSummaryContext(summaryContext) {
        if (summaryContext.triggerKO || summaryContext.triggerPAT) {
            summaryContext.sopPrinted = true;
        }
    }
}
